import Vue from 'vue';
import { helpers } from '@/utility';
import apiServiceAsync from '@/api/apiServiceAsync';

async function getAdultDocumentContent(fileUrl, params, api) {
  const { uuid, token } = params;

  if (!uuid || !token) {
    console.error('Error: Missing url params \'uuid\' and \'token\'.');
    return null;
  }

  const serveFileUrl = fileUrl.startsWith('/') ? fileUrl.substring(1) : fileUrl;
  try {
    return await api.get(`/api/v1/applications/adult-serve-document/${uuid}/${token}/${encodeURIComponent(serveFileUrl)}`, {
      responseType: 'arraybuffer',
      timeout: 0,
    });
  } catch (error) {
    Vue.notify({
      type: 'danger',
      text: Vue.options.filters.translate('unprotected_access_not_allowed'),
    });
    return null;
  }
}

async function getMediaFileContent(fileUrl, api) {
  try {
    return await api.get(`api/v1/serve-media-files?url=${encodeURIComponent(fileUrl)}`, {
      responseType: 'arraybuffer',
      timeout: 0,
    });
  } catch (error) {
    console.error('Error fetching media file');
    return null;
  }
}

function getResponseType(fileExtension) {
  switch (fileExtension) {
    case 'heic':
      return ''; // Handle 'heic' files differently if needed
    default:
      return 'arraybuffer';
  }
}

async function getGeneralFileContent(fileUrl, api) {
  const fileExtension = helpers.getFileExtension(fileUrl);
  const responseType = getResponseType(fileExtension);

  try {
    return await api.get(fileUrl, { responseType, timeout: 0 });
  } catch (error) {
    console.error('Error fetching file.');
    return null;
  }
}

async function getContent(fileUrl) {
  const api = await apiServiceAsync();
  const route = Vue.router?.currentRoute;

  // For unprotected adult document upload view handle serve document properly
  if (route.name === 'AdultDocumentsUploadForm' || route.name === 'StzhAdultDocumentsUploadForm') {
    return getAdultDocumentContent(fileUrl, route.params, api);
  }
  if (/^(\/)?media\//.test(fileUrl)) {
    return getMediaFileContent(fileUrl, api);
  }

  return getGeneralFileContent(fileUrl, api);
}

function triggerDownload(blobData, fileName, contentType) {
  const blob = window.URL.createObjectURL(new Blob([blobData], { type: contentType }));
  const link = document.createElement('a');
  link.href = blob;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    link.remove();
    window.URL.revokeObjectURL(blob);
  }, 100);
}

export default {
  download(fileUrl, overrideFileName) {
    if (fileUrl) {
      return getContent(fileUrl).then((response) => {
        // Strip query from url all after char ?
        const [extractedName] = fileUrl.substr(fileUrl.lastIndexOf('/') + 1).split('?');
        const fileName = overrideFileName || decodeURIComponent(extractedName);
        triggerDownload(response.data, fileName, response.headers['content-type']);
      });
    }
    return Promise.reject(new Error('File url is required'))
      .then(() => {}, (e) => e);
  },
  downloadFile(file, fileName, contentType) {
    if (!file || !fileName || !contentType) return;
    triggerDownload(file, fileName, contentType);
  },
  content(fileUrl) {
    return getContent(fileUrl);
  },
};
